import { useRef, useState } from "react";
import { getToken } from "Session";
import { WhatsAppSessionData, WhatsAppSessionListProps } from "./types";
import QRCode from "qrcode";
import { useInitWebSocket } from "components/atendimentos-components/use-init-web-socket";

export function useSessoesWhatsAppWebSocket() {
  const [isConnect, setIsConnect] = useState(false);
  const [servers, setServers] = useState<WhatsAppSessionListProps[]>([]);
  const [sessionsData, setSessionsData] = useState<
    Map<string, WhatsAppSessionData>
  >(new Map());
  //
  const websocketSettings = {
    url: process.env.REACT_APP_PUBLIC_WEB_SOCKET!,
    headers: { token: getToken(), client: "tela-whatsapp-sessions" },
  };
  const { sendJsonMessage, reconnect } = useInitWebSocket({
    ...websocketSettings,
    onMessage: ({ data }) => {
      const parsedData = JSON.parse(data);
      handleChangeData(parsedData);
    },
    isConnect: servers.length !== 0 && isConnect,
  });
  //
  const sessionsDataRef = useRef<Map<string, WhatsAppSessionData>>(new Map());
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleRender = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    timerRef.current = setTimeout(() => {
      setSessionsData(new Map(sessionsDataRef.current));
      setServers((prev) => {
        prev = prev.map((server) => {
          const currentSessionData = sessionsDataRef.current.get(
            server.whatsappSessionId
          );
          if (currentSessionData) {
            if (currentSessionData.whatsAppNumber) {
              server.whatsAppNumber = currentSessionData.whatsAppNumber;
            }
            if (currentSessionData.portalPage === "chat") {
              server.status = "CONNECTED";
            } else {
              server.status = "DISCONNECTED";
            }
          }
          return server;
        });
        return prev;
      });
    }, 100);
  };

  const handleChangeData = async (data: any) => {
    const whatsappSessionId = data.whatsappSessionId;
    const portalPage = data.state;
    const currentSessionData = sessionsDataRef.current.get(whatsappSessionId);

    let newValue = { ...currentSessionData, portalPage } as WhatsAppSessionData;
    if (portalPage === "chat") {
      if (typeof data.wid === "string") newValue.whatsAppNumber = data.wid;
    } else if (portalPage === "qrcode-generated") {
      const url = await QRCode.toDataURL(data.qrCode);
      newValue.qrCode = url;
    } else if (portalPage === "qrcode-not-generated") {
    }
    sessionsDataRef.current.set(whatsappSessionId, newValue);
    handleRender();
  };

  return {
    sendJsonMessage,
    setIsConnect,
    setServers,
    servers,
    reconnectWs: reconnect,
    sessionsData,
  };
}
